import BiggyBank from "assets/svg/piggy-bank.svg";
import {OreveButton} from "components/button/OreveButton.tsx";
import AddIcon from "@mui/icons-material/Add";
import {Box, FormControl, FormControlLabel, Grid, Radio, RadioGroup, Typography} from "@mui/material";
import { useEffect, useState} from "react";
import {UseAllPaymentContext} from "./payment-context.tsx";

interface RadioItem {
    value: string;
    primary: string;
    secondary?: string;
}

const PaymentMethod = ({ onAddPaymentClick }: { onAddPaymentClick: () => void }) => {

    const { payments } = UseAllPaymentContext();
    const [radioData, setRadioData] = useState<RadioItem[]>([
        { value: 'default', primary: 'Selon modalités à réception de facture' },
    ]);

    const paymentTextType = (text : string) => {
        switch (text) {
            case 'CREDIT_CARD':
                return 'Carte bancaire';
            case 'IBAN':
                return 'IBAN';
            // Ajoutez d'autres cas au besoin
            default:
                return text; // Retourne le texte d'origine si aucune correspondance n'est trouvée
        }
    };

    useEffect(() => {
        if (payments) {
            const updatedRadioData :RadioItem[]  = payments.map(payment => {
                let secondary = '';
                switch (payment.type) {
                    case 'CREDIT_CARD':
                        if ('cardNumber' in payment.payment_data)
                            secondary = `${payment.payment_data.cardNumber} ${payment.payment_data.expirationDate}`;
                        break;
                    case 'IBAN':
                        if ('IBAN' in payment.payment_data && 'BIC' in payment.payment_data)
                            secondary = `${payment.payment_data.IBAN}\n${payment.payment_data.BIC}`;
                        break;
                }
                return {
                    value: payment.id,
                    primary: payment.type,
                    secondary: secondary,
                };

            });
            const defaultPaymentIndex = updatedRadioData.findIndex(item => item.value === 'default');
            if (defaultPaymentIndex === -1) {
                updatedRadioData.unshift({
                    value: 'default',
                    primary: 'Selon modalités à réception de facture',
                });
            }
            setRadioData(updatedRadioData);
        }
    }, [payments]);

    return <Box sx={{
        width: "39%",
        height: "calc(100vh - (80px + 48px + 5rem))",
        p:1,
        backgroundColor: "#FFFFFF",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        borderRadius:"20px",
    }}>
        <img src={BiggyBank} alt="piggy bank"/>
        <OreveButton
            variant={'contained'}
            color={'primary'}
            value="Ajouter un mode de paiement"
            onClick={onAddPaymentClick}
            icon={AddIcon}
            loading={false}
        />
        <Grid container direction="row" alignItems="flex-start" sx={{width: '90%', overflowY: 'auto'}}>
            <Typography
                variant="labelLarge"
                sx={{
                    lineHeight: '20px',
                    letterSpacing: '0.15px',
                    textAlign: 'left',
                    mt: "1.8rem",
                    mb: "1rem",
                }}>
                Mode de paiement par défaut
            </Typography>
            <FormControl sx={{ml:1}}>
                <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    defaultValue="default"
                    name="radio-buttons-group"
                    sx={{flexDirection: 'column'}}
                >
                    {radioData.map((radioItem, index) => (
                        <Box
                            key={index}
                            sx={{
                                ...(index < radioData.length - 1 && {
                                    borderBottom: '1px solid #DDE1E6',
                                    pb: '1rem',
                                }),
                            }}>
                            <FormControlLabel
                                value={radioItem.value}
                                control={<Radio/>}
                                label={
                                    <Box sx={{
                                        ...(index > 0 && {
                                            pt: '1rem',
                                        }),
                                    }}>
                                        <Typography variant="titleSmall">{paymentTextType(radioItem.primary)}</Typography>
                                        <Typography
                                            variant="titleSmall"
                                            sx={{
                                                textAlign: 'left',
                                                color: 'grey.600',
                                                whiteSpace: 'pre-line',
                                            }}>{radioItem.secondary}</Typography>
                                    </Box>
                                }
                            />
                        </Box>
                    ))}
                </RadioGroup>
            </FormControl>
        </Grid>

    </Box>
}

export default PaymentMethod;